import React from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore, useProjectStore } from '@vt/hooks'
import { Button, Separator } from '@ow/comps'
import { IconMaps } from '@ow/icons'
import Text from './Text'
import Pagination from '../pagination'
import Tabs from './Tabs'
import Filter from '../filters'
import ChangeDate from '../filters/Calendar'
import Status from './Status'
import { TriggersMap, defaultElementsConfig } from './constant'

const TriggersWarpper = function ({ element, index }) {
  const { title } = useTbViewStore((state) => pick(state, ['title']))

  const customCompsMap = useProjectStore((state) => state.customCompsMap)
  const { FixedFiltersComponent, ExtBatchTriggersComponent, CustomFilters } =
    customCompsMap || {}

  // 文本
  if (element.type === 'text' && element.actionType !== 'title') {
    const props = {}
    if (element.actionType === 'title') {
      props.message = title
    }
    return <Text props={{ ...element, ...props }} />
  }
  // 分隔符
  if (element.type === 'separator') {
    return <Separator />
  }
  if (element.type === 'ext') {
    return <ExtBatchTriggersComponent />
  }
  // 图标
  if (element.type === 'icon') {
    // 还要渲染操作trigger
    return (
      <IconMaps type={element.icon} width={18} height={18} fill="#A4B1C2" />
    )
  }
  // 分页
  if (element.type === 'pagination') {
    return <Pagination />
  }
  // 按钮、链接
  if (['button', 'linkButton'].includes(element.type)) {
    const Render = TriggersMap[element.actionType]
    const config = defaultElementsConfig[element.actionType]

    if (!config) {
      return null
    }
    const { lable, props, buttonStyle, linkStyle } = config

    if (Render) {
      return (
        <Render>
          {element.type === 'button' ? (
            <Button {...props} style={{ ...buttonStyle, ...element.style }}>
              {element.title || lable}
            </Button>
          ) : (
            <Button
              type={index === 0 && 'primary'}
              stroke={index !== 0}
              style={{
                ...linkStyle,
                ...element.style,
              }}
              className="flex flex-row"
            >
              {element.icon && (
                <IconMaps
                  type={element.icon}
                  width={20}
                  height={20}
                  fill="currentColor"
                />
              )}
              {element.title || lable}
            </Button>
          )}
        </Render>
      )
    }
  }

  // 固定筛选
  if (element.type === 'fixedFilters') {
    return FixedFiltersComponent ? (
      <FixedFiltersComponent>
        <Filter />
      </FixedFiltersComponent>
    ) : (
      <Filter />
    )
  }
  if (element.type === 'status') {
    return <Status />
  }
  // 切换(buttongroup、filter等)
  if (element.type === 'radio') {
    const Render = TriggersMap[element.actionType]
    if (Render) {
      return <Render />
    }
  }
  // 切换日期
  if (element.type === 'changeDate') {
    return <ChangeDate config={element} />
  }

  if (element.type === 'tabs') {
    return <Tabs tabs={element.elements} />
  }

  // 点位导出
  if (element.type === 'export') {
    const Render = TriggersMap[element.actionType]
    if (Render) {
      return <Render />
    }
  }

  if (element.type === 'customFilters') {
    return <CustomFilters />
  }

  return null
}

export default TriggersWarpper
